import React, { useState } from 'react'
import {
  BodyText,
  Container,
  Row,
  Col,
  HeadingText,
  Button,
  CheckmarkBackgroundIcon,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import CheckListBlue from '../../../img/check-list/check-list-blue.png'
import { useApplicationContext } from '../../../context/ApplicationContext'
import apiFactory from '../../../utils/api-factory'

export const UserUnauthorized = () => {
  const { logger, csrf } = useApplicationContext()

  const [emailSent, setEmailSent] = useState({
    attempted: false,
    error: false,
  })

  const [buttonState, setButtonState] = useState('initial')

  const handleSendEmail = async () => {
    setButtonState('processing')
    try {
      const result = await apiFactory.sendUnauthEmail(csrf)
      logger.info(
        `Email sent successfully with notification Id: ${result?.notification_id}`,
      )
      setEmailSent({
        attempted: true,
        error: false,
      })
      setButtonState('success')
    } catch (err) {
      logger.info('Error sending email')
      setEmailSent({
        attempted: true,
        error: true,
      })
      setButtonState('initial')
    }
  }

  return (
    <Container>
      <Row>
        <Col xs={2} />
        <Col xs={8} className="user-unauth-padding-left">
          <Row align="center" className="user-unauth-padding-bottom">
            <img src={CheckListBlue} className="user-unauth-image" />
          </Row>
          <Row align="center">
            <HeadingText size="sm">
              <Message id="full-auth-needed.needPermissionsTitle" />
            </HeadingText>
          </Row>
          <Row align="center" className="user-unauth-padding-top">
            <BodyText align="center">
              <Message id="full-auth-needed.needPermissionsSubtext" />
            </BodyText>
          </Row>
          <Row align="center" className="user-unauth_button">
            {!emailSent.attempted ? (
              <Button onClick={handleSendEmail} btnState={buttonState}>
                <Message id="full-auth-needed.requestPermissionButton" />
              </Button>
            ) : (
              <>
                {!emailSent.error && (
                  <>
                    <CheckmarkBackgroundIcon
                      size="sm"
                      color="sysColorSuccessMain"
                    />
                    <div className="user-unauth_email-sent">
                      <Message id="full-auth-needed.requestSent" />
                    </div>
                  </>
                )}
                {emailSent.error && (
                  <>
                    <div>
                      <Message id="full-auth-needed.requestFailed" />
                    </div>
                  </>
                )}
              </>
            )}
          </Row>
        </Col>
        <Col xs={2} />
      </Row>
    </Container>
  )
}
